<template>
  <!-- 专业岗位查询 -->
  <div class="page">
    <div class="table-search-box">
      <el-form :inline="true" :model="formResourceBase" class="demo-form-inline">
        <div class="drop">
          <div>
            <el-form-item label="查询方式：">
              <el-select size="small" v-model="formResourceBase.type" placeholder="请选择查询方式" :popper-append-to-body="false">
                <el-option v-for="(item,index) in this.queryMethodList" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="学历：">
              <el-select size="small" v-model="formResourceBase.eduName" placeholder="请选择学历" :popper-append-to-body="false">
                <el-option v-for="(item,index) in this.educationList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作经验：">
              <el-select size="small" v-model="formResourceBase.expValue" placeholder="请选择工作经验" :popper-append-to-body="false">
                <el-option v-for="(item,index) in this.experienceList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="技能名称：" >
              <el-input size="small" v-model="formResourceBase.skillName" placeholder="请输入技能名称"></el-input>
            </el-form-item>
            <el-form-item label="节点数：" >
              <el-select size="small" v-model="formResourceBase.size" placeholder="请选择节点数" :popper-append-to-body="false">
                <el-option v-for="(item,index) in this.maxsizeList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <div class="search_button">
                <i class="pointer el-icon-search" @click="search"></i>
                <i class="pointer el-icon-refresh-left" @click="reset"></i>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <div class="graphic">
      <diagramChart :refId="'professionalPostCharts'" :datas='professionalPost.dataList' :links="professionalPost.linksList"></diagramChart>
    </div>
  </div>
</template>

<script>
import diagramChart from '../../components/chart/diagramChart';

export default {
  components: {
    // tree,
    diagramChart,
  },
  data() {
    return {
      queryMethodList: [{value:1,name:'面向职业查询'}, {value:2,name:'可从事职业推荐'}], // 选择查询方式
      professionalList: [], // 专业名称
      educationList: ['全部','无要求', '初中及以下', '高中/中专/中技', '大专', '本科', '硕士', '博士'], // 学历选择
      maxsizeList: [50, 100, 150, 200,250,300], // 节点数选择
      experienceList:['全部','1年经验','2年经验','3-4年经验','5-7年经验','8-9年经验'],
      formResourceBase: {
        type: 1,
        eduName: '',
        expValue: '',
        skillName: '',
        size: 50,
      },
      colorList: ['#1CEBEE', '#524BE8', '#D152E8', '#E8BF52', '#D3F267', '#AFF271', '#93F0AF', '#74EDE5', '#E7CF34', '#1BF6F8', '#FA2A80', '#3B86FF', '#48F8C8'],
      identification: [], // 标识

      professionalPost: {
        dataList: [],
        linksList: [],
        colorList: [],
        identifying: 1,
      },
    };
  },
  created() {
    // this.source()
    // if (sessionStorage.getItem('zykId')) {
    //   this.formResourceBase.professionalName = sessionStorage.getItem('zykId');
    //   this.polling(this.formResourceBase.queryMethod, sessionStorage.getItem('zykId'));
    // } else {
    //   this.polling(this.formResourceBase.queryMethod, null);
    // }
    this.search()
  },
  methods: {
    // 获取专业数据
    search(){
      let obj = this.formResourceBase
      this.$axios.post(this.$apiurls.puxitu_queryMajorSkillMaps,obj,{
      }).then((res)=>{
        res.data.data.nodes.forEach(item =>{
            this.professionalPost.dataList.push(item.data)
          })

          res.data.data.links.forEach(item =>{
            this.professionalPost.linksList.push(item.data)
          })
      })
    },
    // 查询
    // polling(queryMethod, professionalName) {
    //   let url = '';
    //   let obj = {};
    //   switch (queryMethod) {
    //     case '能胜任岗位':
    //       url = this.$apiurls.positionQuery_getChartByMajorEducationExperience;
    //       obj = {
    //         education: this.formResourceBase.education,
    //         experience: this.formResourceBase.experience,
    //         major: professionalName || this.formResourceBase.professionalName,
    //         maxsize: this.formResourceBase.maxsize,
    //       };
    //       break;
    //     case '能适应、感兴趣的岗位':
    //       url = this.$apiurls.positionQuery_getChartBySkill;
    //       obj = {
    //         skill: this.formResourceBase.skill,
    //         maxsize: this.formResourceBase.maxsize,
    //       };
    //       break;
    //     default:
    //       url = this.$apiurls.positionQuery_getChartByPositionName;
    //       obj = {
    //         positionName: this.formResourceBase.positionName,
    //         maxsize: this.formResourceBase.maxsize,
    //       };
    //       break;
    //   }
    //   this.$axios.post(url, obj, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.professionalPost.dataList = res.data.neo4jData;
    //       this.professionalPost.linksList = res.data.links;
    //       console.log(this.professionalPost.dataList,this.professionalPost.linksList)
    //     }
    //   });
    // },
    // 重置
    reset() {
      this.formResourceBase.queryMethod = this.queryMethodList[0];
      this.formResourceBase.professionalName = this.professionalList[0].zykId;
      this.formResourceBase.skill = '';
      this.formResourceBase.positionName = '';
      this.formResourceBase.education = this.educationList[0];
      this.formResourceBase.maxsize = this.maxsizeList[0];
      this.formResourceBase.experience = 0;
      this.polling(this.queryMethodList[0], this.professionalList[0].zykId);
    },
  },
};
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/custom.scss" scoped></style>
<style scoped>
/* 下拉框 */
.roll_page {
  height: calc(100% - 90px);
}

.drop {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search_button {
  color: aqua;
  line-height: 0px;
  display: flex;
  align-items: center;
}
.search_button i {
  width: 32px;
  height: 32px;
  background: rgba(46, 62, 99, 0.39);
  border-radius: 4px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
}

/* 图表 */
.graphic {
  width: 100%;
  height: calc(100% - 65px);
  position: relative;
}
</style>
